import Result from './Result';
import { useContext } from 'react';
import { DataContext } from './DataProvider';
const BottomArea = ({ cHeight, mousekey }) => {
    const { viewPosition } = useContext(DataContext);

    const divStyle = {
        width: viewPosition ? cHeight ? `calc(70% + ${cHeight}px - 15px)` : "70%" : "100%",
        height: viewPosition ? "100%" : cHeight ? `calc((50% - 15px) + ${cHeight}px)` : `calc(50% - 15px)`,
        background: "rgba(255, 255, 255, 1)",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        position: "relative",

        gDiv: {
            width: "100%",
            height: "100%",
            background: "transparent",
            position: "absolute",
            top: "0",
            pointerEvents: mousekey ? "all" : "none",
        }
    }

    return (
        <div style={divStyle}>
            <div style={divStyle.gDiv}></div>
            <Result cHeight={cHeight} />
        </div>
    );
}

export default BottomArea;